import * as Promise from 'bluebird';

export const openDatabaseDesktop = ({ name, databaseVersion, databaseDescription }) =>
  new Promise(success => {
    if (window && window.require) {
      const path = window.require('path');
      const electron = window.require('electron');
      const remote = electron.remote;
      window.module.paths.push(path.resolve('./node_modules'));
      window.module.paths.push(path.join(remote.getGlobal('appPath'), 'node_modules'));
      console.log('MODULE_PATHS', window.module.paths);

      const openWebsqlDatabase = window.require('websql');
      const fs = remote.require('fs-extra');
      const appDataPath = path.join(remote.getGlobal('appDataPath'), 'databases');

      fs.mkdirpSync(appDataPath);

      success(
        openWebsqlDatabase(path.join(appDataPath, name), databaseVersion, databaseDescription, 100 * 1024 * 1024)
      );
    } else {
      throw new Error('Not running on electron');
    }
  });
